import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center",
  style: {"max-height":"70vh"}
}
const _hoisted_2 = {
  key: 1,
  class: "text-center",
  style: {"max-height":"70vh"}
}
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createBlock(_component_oss_dialog, {
    modelValue: _ctx.dialog,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dialog) = $event)),
    title: "Importer",
    "min-width": "60vw"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "d-flex justify-center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "4" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.sire,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sire) = $event)),
                placeholder: _ctx.sirenMode ? 'N°SIREN' : 'N°SIRET',
                outlined: "",
                rules: [
                        (siren) =>
                            (!!_ctx.sire && !!this.sire.match(/^[0-9]{9}$/)) ||
                            (!!this.sire && !!this.sire.match(/^[0-9]{14}$/)) ||
                            'Mauvais format',
                    ],
                density: "compact"
              }, null, 8, ["modelValue", "placeholder", "rules"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "8" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_data_table_server, {
                headers: _ctx.headers,
                items: _ctx.items,
                page: _ctx.pagination.page,
                "onUpdate:page": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pagination.page) = $event)),
                "sort-by": _ctx.pagination.sortBy,
                "onUpdate:sortBy": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pagination.sortBy) = $event)),
                "items-per-page": _ctx.pagination.rowsPerPage,
                "onUpdate:itemsPerPage": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pagination.rowsPerPage) = $event)),
                "items-length": _ctx.companiesCount,
                "items-per-page-options": [5, 10, 25],
                loading: _ctx.loading,
                class: "table",
                "loading-text": "Recherche de votre société en cours ..."
              }, {
                "no-data": _withCtx(() => [
                  (_ctx.sire !== '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Aucune Société n'a été trouvé avec ce " + _toDisplayString(_ctx.sirenMode ? "SIREN" : "SIRET"), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_2, " Entrez votre numero de " + _toDisplayString(_ctx.sirenMode ? "Siren" : "Siret"), 1))
                ]),
                item: _withCtx((props) => [
                  _createElementVNode("tr", {
                    onClick: ($event: any) => (_ctx.close(props.item))
                  }, [
                    _createElementVNode("td", null, _toDisplayString(props.item.name), 1),
                    _createElementVNode("td", null, _toDisplayString(props.item.siret), 1),
                    _createElementVNode("td", null, _toDisplayString(props.item.address), 1),
                    _createElementVNode("td", null, [
                      _createVNode(_component_v_btn, {
                        elevation: "0",
                        disabled: props.item.isActive === false,
                        size: "small"
                      }, {
                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                          _createTextVNode(" Choisir ")
                        ])),
                        _: 2
                      }, 1032, ["disabled"])
                    ])
                  ], 8, _hoisted_3)
                ]),
                _: 1
              }, 8, ["headers", "items", "page", "sort-by", "items-per-page", "items-length", "loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}